<template>
  <div class="segmental-control">
    <div
      class="segmental-control__item"
      :class="{
        active: selectedButton === button.value,
        'style-basic': itemStyle === 'style-basic',
        'style-primary': itemStyle === 'style-primary',
      }"
      v-for="button in buttons"
      :key="button.value"
      @click="selectOption(button.value)"
    >
      {{ button.title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttons: {
      type: Array,
      default: () => [
        {
          value: 1,
          title: '訂閱中',
        },
        {
          value: 0,
          title: '取消訂閱',
        },
      ],
    },
    itemStyle: {
      type: String,
      default: 'style-basic',
    },
    value: {
      type: [Number, String],
      default: null,
    },
  },
  data: () => ({
    selectedButton: null,
  }),
  watch: {
    selectedButton() {
      this.$emit('input', this.selectedButton);
    },
    value() {
      this.selectedButton = this.value;
    },
  },
  mounted() {
    const vm = this;
    vm.selectedButton = vm.value;
  },
  methods: {
    selectOption(value) {
      if (value === this.selectedButton) {
        this.selectedButton = null;
      } else {
        this.selectedButton = value;
      }
    },
  },
};
</script>

<style lang="scss">
.segmental-control {
  display: inline-flex;
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 88px;
    height: 40px;
    font-size: 14px;
    cursor: pointer;

    &.style-basic {
      color: #848fa0;
      box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
        0 0 1px 0 rgba(4, 48, 71, 0.1);
      border: solid 0.5px #d7dee7;
      border-left-style: none;
      background-color: #ffffff;

      &:first-of-type {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border: solid 0.5px #d7dee7;
      }

      &:last-of-type {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-left-style: none;
      }

      &.active {
        color: #353e4d;
        box-shadow: inset 0 1px 8px 0 rgba(0, 0, 0, 0.1),
          inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);
        background-color: #f5f7f8;
      }
    }

    &.style-primary {
      font-size: 14px;
      color: #194cc3;
      box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
        0 0 1px 0 rgba(4, 48, 71, 0.1);
      border: solid 1px #194cc3;
      border-left-style: none;
      background-color: #ffffff;

      &:first-of-type {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        border: solid 1px #194cc3;
      }
      &:last-of-type {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        border-left-style: none;
      }
      &.active {
        color: white;
        box-shadow: 0 1px 2px 0 rgba(4, 48, 71, 0.06),
          0 0 1px 0 rgba(4, 48, 71, 0.1);
        background-color: #1e50c0;
      }
    }
  }
}
</style>
